import styled from 'styled-components';
import { Absolute } from '../Absolute/Absolute';
export const AbsoluteTransformLeft = /*#__PURE__*/styled(Absolute).withConfig({
  displayName: "Arrowstyled__AbsoluteTransformLeft",
  componentId: "sc-17mtqml-0"
})(["transform:translateX(-50%);"]);
export const AbsoluteTransformRight = /*#__PURE__*/styled(Absolute).withConfig({
  displayName: "Arrowstyled__AbsoluteTransformRight",
  componentId: "sc-17mtqml-1"
})(["transform:translateX(50%);"]);
export const ARROW_SIZES = {
  sm: {
    buttonSize: 40,
    iconSize: 32
  },
  lg: {
    buttonSize: [40, null, null, null, 60],
    iconSize: [32, null, null, null, 40]
  }
};